import { createFileRoute } from "@tanstack/react-router";
import { useRecordTypeDrawerContext } from "@/utils/record-type-detail/record-type-drawer-context";
import { RecordTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/activity",
)({
	component: AdminRecordTypeActivityTab,
});

function AdminRecordTypeActivityTab() {
	const { recordType } = useRecordTypeDrawerContext();

	return (
		<div className="p-4">
			<RecordTypeActivitySection recordType={recordType} />
		</div>
	);
}
